import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DoneIcon from '@mui/icons-material/Done';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Box, Button, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from "yup";
import { cfpBaseUrl } from '../../../network/urls';
import "./OptForSmartMeterForm.scss";
import { documentExtensions } from '../../../utils/PortalName';

const Optforsmartmeterdocuments = () => {

    const initialValues = {
        // Required Documents Initial Values
        iv_applicant_cnic_document: null,
        iv_applicant_last_paid_bill: null,
    }
    const [isLoadingSpinner, setIsLoadingSpinner] = React.useState(false);

    // Documents states
    const [applicantCnicDocument, setApplicantCnicDocument] = useState('');
    const [lastPaidBill, setLastPaidBill] = useState('');

    // Thumbnail states
    const [applicantCnicDocumentThumbnail, setApplicantCnicDocumentThumbnail] = useState(null);
    const [lastPaidBillThumbnail, setLastPaidBillThumbnail] = useState(null);

    const { state } = useLocation();
    const { dialogRowData } = state;
    const [dialogRowDataLocal, setDialogRowDataLocal] = useState();
    const officeCode = parseInt(JSON.parse(window.localStorage.getItem('user-office-code')))

    var token = JSON.parse(window.localStorage.getItem('user-token'))

    const navigate = useNavigate();

    useEffect(() => {
        if (dialogRowData) {
            let dialogData = dialogRowData
            setDialogRowDataLocal(dialogData)
        }
    }, [dialogRowData])

    useEffect(() => {
        if (dialogRowDataLocal) {
            console.log(dialogRowDataLocal, 'Printing local state')
        }
    }, [dialogRowDataLocal])

    useEffect(() => {
        if (dialogRowData.copyOfApplicantCNIC) {
            values.iv_applicant_cnic_document = dialogRowData.copyOfApplicantCNIC
            setApplicantCnicDocumentThumbnail(dialogRowData.copyOfApplicantCNIC)
        }
        if (dialogRowData.applicantLastPaidBill) {
            values.iv_applicant_last_paid_bill = dialogRowData.applicantLastPaidBill
            setLastPaidBillThumbnail(dialogRowData.applicantLastPaidBill)
        }
    }, [dialogRowData])

    useEffect(() => {
        console.log(dialogRowData, 'printing Application in update page')
    }, [dialogRowData])

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            validationSchema: Yup.object({
                // Required Documents Validation
                iv_applicant_cnic_document: Yup.mixed().required('Please upload cnic in jpg, jpeg, png or pdf format.'),
                iv_applicant_last_paid_bill: Yup.mixed().required('Please upload last paid bill in jpg, jpeg, png or pdf format.'),
            }),
            onSubmit: (values, { resetForm }) => {
                setIsLoadingSpinner(true);
                let userName = JSON.parse(window.localStorage.getItem('user-name'))
                var formdata = new FormData();

                console.log(applicantCnicDocumentThumbnail, 'Applicant CNIC')
                console.log(lastPaidBillThumbnail, 'last bill')
                formdata.append("applicationId", dialogRowData.applicationId);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);;
                formdata.append("copyOfApplicantCNIC", applicantCnicDocumentThumbnail);
                formdata.append("applicantLastPaidBill", lastPaidBillThumbnail);
                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };

                fetch(cfpBaseUrl + "optForSmartMeter/optDocumentUpdate", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === "200") {
                            var formdata = new FormData();
                            formdata.append("applicationId", dialogRowData.applicationId);
                            const myHeaders = new Headers();
                            myHeaders.append("Authorization", token);;
                            if (applicantCnicDocumentThumbnail) {
                                formdata.append("copyOfApplicantCNICFlag", 1);
                            }
                            else {
                                formdata.append("copyOfApplicantCNICFlag", "");
                            }
                            if (lastPaidBillThumbnail) {
                                formdata.append("applicantLastPaidBillFlag", 1);
                            }
                            else {
                                formdata.append("applicantLastPaidBillFlag", "");
                            }
                            var requestOptions = {
                                method: 'POST',
                                body: formdata,
                                headers: myHeaders,
                                redirect: 'follow',
                            };

                            fetch(cfpBaseUrl + "optForSmartMeter/updateCNICFlag", requestOptions)
                                .then(response => response.json())
                                .then(result => {
                                    if (result.status === "200") {
                                        var formdata = new FormData();
                                        formdata.append("applicationId", dialogRowData.applicationId);
                                        formdata.append("objectionStatus", 0);
                                        formdata.append("reamrks", 'Documents uploaded.');
                                        formdata.append("lastModifiedBy", userName);
                                        const myHeaders = new Headers();
                                        myHeaders.append("Authorization", token);;
                                        var requestOptions = {
                                            method: 'POST',
                                            body: formdata,
                                            headers: myHeaders,
                                            redirect: 'follow',
                                        };

                                        fetch(cfpBaseUrl + "electricityNewConnection/objectionStatus", requestOptions)
                                            .then(response => response.json())
                                            .then(result => {
                                                if (result.status === '200') {
                                                    // toast.success(result.message);

                                                    var formdata = new FormData();
                                                    formdata.append("applicationId", dialogRowData.applicationId);
                                                    formdata.append("lastModifiedBy", userName);
                                                    formdata.append("applicationProgressId", 2);
                                                    const myHeaders = new Headers();
                                                    myHeaders.append("Authorization", token);;

                                                    var requestOptions = {
                                                        method: 'POST',
                                                        body: formdata,
                                                        headers: myHeaders,
                                                        redirect: 'follow',
                                                    };
                                                    fetch(cfpBaseUrl + "electricityNewConnection/encChangeProgressId", requestOptions)
                                                        .then(response => response.json())
                                                        .then(result => {
                                                            if (result.status === '200') {
                                                                console.log(result, 'Called API')
                                                                let lclStrdOptApp = JSON.parse(window.localStorage.getItem('opt-for-smart-meter-applications'));
                                                                const index = lclStrdOptApp.findIndex(item => item.applicationId === dialogRowData.applicationId);
                                                                console.log(index, 'Item Found')
                                                                lclStrdOptApp[index].applicationProgressId = 2
                                                                window.localStorage.setItem('opt-for-smart-meter-applications', JSON.stringify(lclStrdOptApp));
                                                                // toast.success("Status of application: " + result.applicationId + " has be set to '" + 'Documents Verified' + "'.")
                                                                try {
                                                                    console.log('Application Updated!')
                                                                    setIsLoadingSpinner(false)
                                                                }
                                                                catch (error) {
                                                                    console.log(error, 'Printing error')
                                                                }
                                                                setTimeout(() => {
                                                                    navigate('/opt-for-smart-meter-table')
                                                                }, 2000)
                                                            }
                                                            else {
                                                                console.log(result.message)
                                                            }
                                                        })
                                                        .catch(error => console.log('error', error));

                                                }
                                                else {
                                                    console.log(result.message)
                                                }
                                            })
                                            .catch(error => console.log('error', error));
                                    }
                                })
                                .catch(error => console.log('error', error));
                        }
                        else {
                            setIsLoadingSpinner(false)
                            console.log(result.message);
                        }
                    })
                    .catch(error => {
                        setIsLoadingSpinner(false)
                        console.log(error);
                    });
            }
        })

    useEffect(() => {
        console.log(dialogRowData, 'RowData')
    }, [])

    //Function to set states of documents
    const ApplicantCnicDocument = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "copyOfApplicantCNIC." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setApplicantCnicDocument(renamedFile);
                const reader = new FileReader();

                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setApplicantCnicDocumentThumbnail(e.target.result);
                };

                reader.readAsDataURL(file);
            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const LastPaidBill = (event) => {
        handleChange(event);
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            let fileName = file.name
            let fileNameArray = fileName.split('.')
            let extension = fileNameArray[fileNameArray.length - 1]
            console.log(extension, 'Printing Extension');
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            const documentValidate = documentValidation(file, maxSize)
            if (documentValidate === 1) {
                const newFileName = "lastPaidBill." + extension;
                const renamedFile = new File([file], newFileName, { type: file.type });
                setLastPaidBill(renamedFile);
                const reader = new FileReader();

                reader.onload = (e) => {
                    // Set the thumbnail image as the data URL
                    setLastPaidBillThumbnail(e.target.result);
                };

                reader.readAsDataURL(file);
            } else if (documentValidate === 2) {
                console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
            } else {
                console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
            }
        }
    }

    const documentValidation = (file, maxSize) => {
        console.log(file);
        let fileExtension = file.name.split(".").pop();

        if (["jpg", "png", "pdf", "JPG", "PNG", "jpeg", "JPEG", "PDF"].includes(fileExtension.toLowerCase())) {
            if (file.size <= maxSize) {
                return 1
            } else {
                return 2
            }
        } else {
            return 3
        }
    }


    return (
        <Grid container className='nC'>
            <Box className='nCContainer'>
                <Typography variant='h6' className='heading'>
                    New Connection Form
                </Typography>
                {/* <p style={{ textAlign: 'right', marginRight: '7%' }}>Application Id {dialogRowData.applicationId}</p> */}
                <Box className="progressBarBackground">
                    <Box className="progressBarContainer">
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    dialogRowData.copyOfApplicantCNIC || applicantCnicDocument
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>1</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Applicant's CNIC.</Typography>
                        </Box>
                        <Box className="pbDocGroup">
                            <Typography className="badge">
                                {
                                    dialogRowData.applicantLastPaidBill || lastPaidBill
                                        ?
                                        <Box className='backgroundAttached'>
                                            <DoneIcon className='icon' />
                                        </Box> :
                                        <p className='backgroundUnAttached'>2</p>
                                }
                            </Typography>
                            <Typography className='badgeText'>Property Documents</Typography>
                        </Box>
                    </Box>
                </Box>
                <form className='ncform'>
                    <Typography variant="h6" className='groupTitle' >
                        Application Details
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={4}>
                            <Typography className='fieldLabel' > Application Id</Typography>
                            <TextField
                                required
                                type='text'
                                name="iv_applied_load"
                                value={dialogRowData.applicationId}
                                disabled
                                id="iv_applied_load"
                                className='textInputField'
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography className='fieldLabel' >  Payment Plan</Typography>
                            <TextField
                                autoWidth={false}
                                value={dialogRowData.installmentPlan}
                                disabled
                                className='textInputField'
                                name="iv_installment_plan"
                                id="iv_installment_plan"
                            />
                        </Grid>
                    </Grid>

                    <Typography variant="h6" className='groupTitle'>
                        Documents
                    </Typography>
                    <Grid container spacing={1} className='documentsContainer' >
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >1- Applicant's CNIC.</Typography>
                            <Box className='documentError'>{errors.iv_applicant_cnic_document && touched.iv_applicant_cnic_document ? (errors.iv_applicant_cnic_document) : null}</Box>
                        </Grid>
                        <Grid item lg='4'>
                            {
                                dialogRowData.copyOfApplicantCNIC ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={applicantCnicDocumentThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            (!dialogRowData.copyOfApplicantCNICFlag || dialogRowData.copyOfApplicantCNICFlag === -1) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                    Change
                                                    <input hidden accept={documentExtensions} id='iv_applicant_cnic_document' name='iv_applicant_cnic_document' type="file" onChange={ApplicantCnicDocument} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    applicantCnicDocument ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setApplicantCnicDocument('') }} />}  >
                                                {applicantCnicDocumentThumbnail && <img src={applicantCnicDocumentThumbnail} alt="Applicant CNIC" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_applicant_cnic_document' name='iv_applicant_cnic_document' type="file" onChange={ApplicantCnicDocument} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                        <Grid item lg='2' >
                            <Typography className='documentLabel' >2- Last Paid Bill</Typography>
                            <Box className='documentError'>{errors.iv_applicant_last_paid_bill && touched.iv_applicant_last_paid_bill ? (errors.iv_applicant_last_paid_bill) : null}</Box>
                        </Grid>
                        <Grid item lg='4'>
                            {
                                dialogRowData.applicantLastPaidBill ?
                                    <Grid container>
                                        <Grid item sm={6}>
                                            <img src={lastPaidBillThumbnail} style={{ width: '50%' }} />
                                        </Grid>
                                        {
                                            (!dialogRowData.applicantLastPaidBillFlag || dialogRowData.applicantLastPaidBillFlag === -1) &&
                                            <Grid item sm={6}>
                                                <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} />}  >
                                                    Change
                                                    <input hidden accept={documentExtensions} id='iv_applicant_last_paid_bill' name='iv_applicant_last_paid_bill' type="file" onChange={LastPaidBill} />
                                                </Button>
                                            </Grid>
                                        }
                                    </Grid>
                                    :
                                    lastPaidBill ?
                                        <>
                                            <Button varient='contained' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setLastPaidBill('') }} />}  >
                                                {lastPaidBillThumbnail && <img src={lastPaidBillThumbnail} alt="Last Paid Bill" width="100" />}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button variant="contained" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                                                Upload
                                                <input hidden accept={documentExtensions} id='iv_applicant_last_paid_bill' name='iv_applicant_last_paid_bill' type="file" onChange={LastPaidBill} />
                                            </Button>
                                        </>
                            }
                        </Grid>
                    </Grid>
                    <Box sx={{ marginTop: '1%' }}>
                        <Button sx={{ width: '35%', marginLeft: '1%', marginBottom: '1%' }} variant="contained" component="label" type='submit' onClick={handleSubmit} disabled={isLoadingSpinner}>
                            {isLoadingSpinner ? (
                                <Box sx={{ display: 'flex' }}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                'Submit'
                            )}
                        </Button>
                        < ToastContainer autoClose={5000} style={{ width: '50%' }} theme="colored" />
                    </Box>
                </form >
            </Box >
        </Grid >
    )
}

export default Optforsmartmeterdocuments
